import React from "react";
import { FireIcon } from "@heroicons/react/outline";
import { isTrueOrUndefined } from "Utils";
import { getLocalStorageItem } from "helpers/LocalStorage";

function HotTip(props) {
    if (isTrueOrUndefined(getLocalStorageItem("local_hotTips"))) {
        return (
            <div>
                <div className="my-1 flex items-center space-x-2 rounded bg-white py-2 px-4 text-xs shadow">
                    <FireIcon className="h-5 w-5 text-red-600" />
                    <div>{props.children}</div>
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default HotTip;
